export function extractFileNameAndExtension(filePath) {
  if (filePath) {
    const pathSegments = filePath.split(/[\\/]/); 
    const fileNameWithExtension = pathSegments[pathSegments.length - 1]; 
    return fileNameWithExtension;
  } else {
    return 'NotFound';
  }
}
